import type { IJobsDetailTemplateProps } from 'src/components-v3/Careers/CareersSearch.types';
import JobDetailTemplate from 'src/components-v3/Careers/JobDetail/JobDetailTemplate';
import {
  buildJobDetailMetaData,
  getDepartmentDescription,
  getJobDetailPathsAndBuildCache,
} from 'src/components-v3/Careers/helpers';
import Ashby from 'src/lib/ashby-client';

export interface IJobPageProps extends IJobsDetailTemplateProps {
  preview?: boolean;
}

const JobDetailPage = (props: IJobsDetailTemplateProps) => {
  return <JobDetailTemplate {...props} />;
};

// Static build: pre-generates every job detail page at build time.
// Multi-location postings get a canonical `{dept}/{slug}` page plus one
// `{dept}/{location}/{slug}` page per location (kept for SEO, canonical back).
// Single-location postings get one `{dept}/{location}/{slug}` page.
export async function getStaticPaths() {
  const paths = await getJobDetailPathsAndBuildCache();
  return { paths, fallback: false };
}

export async function getStaticProps({ params, preview }) {
  const slugParts: string[] = params.slug;
  const key = slugParts.join('/');

  let job = await Ashby.cache.get(key);

  // build cache on miss (jobs.db missing or stale)
  if (!job) {
    await getJobDetailPathsAndBuildCache();
    job = await Ashby.cache.get(key);
  }

  if (!job) {
    return { notFound: true };
  }

  const intro = await getDepartmentDescription(job.categories?.team);
  const { sanitizedJob, metaData } = await buildJobDetailMetaData({
    job,
    slugParts,
    intro,
  });

  return {
    props: {
      job: sanitizedJob,
      intro,
      metaData,
      otherJobs: job.otherJobs || [],
      preview: !!preview,
    },
  };
}

export default JobDetailPage;
